import React, { useState } from 'react';
import './ShowContentForUser.css'; // CSS file for styling the modal

const ShowContentForUser = ({ onClose, myIframe, width, height }) => {
  return (
    <div className="modal-overlay">
    <div className="modal-content"  style={{ width: `${width}px`, height: `${height}px` }}>
      <div className="iframe-container">
        {myIframe}
      </div>
      <button className="close-button" onClick={onClose}>Cerrar</button>
    </div>
  </div>
  );
};

export default ShowContentForUser;